import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PrivateClassLesson } from '../private-class-lesson-dto';

export const FREE_FORM_LESSON_UUID = 'pc_free_form_lesson';

@Component({
  selector: 'lp2-private-class-download-slides-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <a
      *ngIf="showLessonMaterialDownloadButton"
      class="download-button link-button fw-bold fst-italic m-0"
      (click)="downloadLessonMaterial($event, lesson.lessonMaterialUrl)"
      target="_blank"
    >
      {{ 'oern.pc.buttons.slides' | translate }} <i class="fa-icon fa fa-download pl-1"></i>
    </a>
  `,
})
export class PrivateClassDownloadSlidesLinkComponent {
  @Input() lesson: PrivateClassLesson;

  public downloadLessonMaterial(event: Event, url: string) {
    window.open(url, '_blank');
    event.stopPropagation();
  }

  public get showLessonMaterialDownloadButton(): boolean {
    return this.lesson && this.lesson.lessonMaterialUrl && this.lesson.uuid !== FREE_FORM_LESSON_UUID;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-download-slides-link/private-class-download-slides-link.component.ts